import { IEntity } from "./Entity";
import { IProject } from "./Project";

export interface IPPAppProjectFinancial extends IEntity {
    ProjectID?: number;
    FYLabel?: string;
    FYValue?: number;

    Project?: IProject;
}

export class PPAppProjectFinancial implements IPPAppProjectFinancial {
    public ID: number = 0;
    public Title: string = null;
    public ProjectID?: number = null;
    public FYLabel?: string = null;
    public FYValue?: number = null;    

    constructor(projectID: number) {
        this.ProjectID = projectID;
    }
}